import { isNullable } from './isNullable';

/**
 * Zwraca obiekt z usuniętymi pustymi subobiektami
 *
 * @export
 * @param {*} object
 * @returns {*}
 */
export function removeEmptyObjectFields(object: any): any {
  if (!object) {
    return object;
  }

  const keys = Object.keys(object);
  if (!keys.length) {
    return undefined;
  }

  const result: any = {};
  keys.forEach(key => {
    const value = object[key];
    if (isNullable(value)) {
      return value;
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
      const objectValue = removeEmptyObjectFields(removeEmptyObjectFields(value));
      result[key] = objectValue;
      return;
    }
    result[key] = value;
  });
  return result;
}
